// Environment for local development
export const environment = {
  
  production: false,
  backendUrl: '/api'
};
